export const environment = {
  production: false,
  env: 'dev',
  version: 'dev-d244035b',
  feedbackDelay: 5000,
  api: 'https://0gpb73cah0.execute-api.us-west-2.amazonaws.com',
};
